export default (page, pageSize, data) =>
  data.slice && data.slice(page * pageSize, (page + 1) * pageSize);
